import React from "react";
import { Link } from "react-router-dom";
import heroImage from "../assets/zeamays.png";

const PolicyPageLayout = ({ title, intro, sections, contactEmail, contactPhone, lastUpdated }) => {
  return (
    <div className="w-full">
      <section
        className="relative mt-16 overflow-hidden bg-[radial-gradient(circle_at_top_left,_rgba(190,242,100,0.22),_transparent_30%),linear-gradient(180deg,#0f2417_0%,#17311f_45%,#f7fbef_100%)]"
      >
        <div className="absolute inset-0 bg-[linear-gradient(120deg,rgba(15,23,42,0.45),rgba(15,23,42,0.12))]" />
        <div className="relative mx-auto grid min-h-[420px] max-w-7xl items-center gap-8 px-6 py-16 lg:grid-cols-[1.1fr_0.9fr] lg:px-8">
          <div className="max-w-3xl text-white">
            <div className="inline-flex rounded-full border border-white/15 bg-white/10 px-4 py-2 text-xs font-semibold uppercase tracking-[0.26em] text-lime-100 backdrop-blur">
              Legal & policy
            </div>
            <h1 className="mt-6 text-4xl font-black tracking-tight sm:text-5xl lg:text-6xl">
              {title}
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-8 text-slate-100 sm:text-lg">
              {intro}
            </p>
          </div>

          <div className="relative">
            <div className="absolute -left-6 top-10 h-24 w-24 rounded-full bg-lime-300/20 blur-3xl" />
            <div className="absolute -right-4 bottom-8 h-32 w-32 rounded-full bg-red-500/20 blur-3xl" />
            <div className="relative overflow-hidden rounded-[2rem] border border-white/20 bg-white/10 p-3 shadow-[0_30px_80px_rgba(15,23,42,0.3)] backdrop-blur-xl">
              <img
                src={heroImage}
                alt="Zea Mays Foods"
                className="h-[320px] w-full rounded-[1.5rem] object-cover"
                width="1200"
                height="800"
                loading="eager"
                decoding="async"
              />
              <div className="absolute inset-x-6 bottom-6 rounded-[1.25rem] border border-white/15 bg-slate-950/55 p-4 text-white backdrop-blur">
                <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-lime-200">
                  Zea Mays Foods
                </p>
                <p className="mt-1 text-lg font-bold">Clear policies. Better customer confidence.</p>
                <p className="mt-1 text-sm text-slate-200">
                  Last updated: {lastUpdated || "today"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="px-4 py-16 text-slate-900 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-5xl space-y-6">
          {sections.map((section) => (
            <article
              key={section.title}
              className="rounded-[1.75rem] border border-lime-200 bg-white/90 p-6 shadow-[0_16px_40px_rgba(15,23,42,0.06)] backdrop-blur"
            >
              <h2 className="text-2xl font-bold text-slate-950">{section.title}</h2>
              <div className="mt-4 space-y-4 text-sm leading-7 text-slate-600">
                {section.body.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </div>
              {section.items?.length ? (
                <ul className="mt-5 grid gap-3 sm:grid-cols-2">
                  {section.items.map((item) => (
                    <li
                      key={item}
                      className="rounded-2xl border border-lime-100 bg-lime-50/60 px-4 py-3 text-sm leading-6 text-slate-700"
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              ) : null}
            </article>
          ))}

          <article className="rounded-[1.75rem] border border-slate-200 bg-slate-950 p-6 text-white shadow-[0_16px_40px_rgba(15,23,42,0.16)]">
            <h2 className="text-2xl font-bold">Contact Us</h2>
            <p className="mt-3 max-w-3xl text-sm leading-7 text-slate-200">
              If you have any questions about this policy or need help with your order, please reach out.
            </p>
            <div className="mt-5 flex flex-col gap-3 text-sm text-slate-200 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <span className="font-semibold text-lime-200">Email:</span>{" "}
                <a className="underline decoration-lime-400/70 underline-offset-4" href={`mailto:${contactEmail}`}>
                  {contactEmail}
                </a>
              </div>
              <div>
                <span className="font-semibold text-lime-200">Phone:</span>{" "}
                <a className="underline decoration-lime-400/70 underline-offset-4" href={`tel:${contactPhone}`}>
                  {contactPhone}
                </a>
              </div>
            </div>
            <div className="mt-6">
              <Link
                to="/contact"
                className="inline-flex rounded-full bg-red-700 px-5 py-3 text-sm font-semibold text-white transition hover:bg-red-800"
              >
                Contact Support
              </Link>
            </div>
          </article>
        </div>
      </section>
    </div>
  );
};

export default PolicyPageLayout;
